import { useAppSelector } from '@store';
import ExpandableRow from './expandable-row';
import ExpandableRowContent from './expandable-row-content';
import { RiskScoringTypes } from '../../../hoc/customers/types';
import { AmlComponentProps } from './types';

const TypeOfClient = ({
  expandedRows,
  setExpandedRows,
  values,
  // onSend,
  // onDelete,
  isEditable,
}: AmlComponentProps) => {
  const { clientsActivities } = useAppSelector(
    (state) => state.customersDictionaries,
  );

  return (
    <ExpandableRow
      name={RiskScoringTypes.TYPE_OF_CLIENT}
      title="Type of client"
      expandedRows={expandedRows}
      setExpandedRows={setExpandedRows}
      totalRisk={values?.clientActivityRisk as number}
      // comments={[]}
      // onSend={onSend}
      // onDelete={onDelete}
    >
      <ExpandableRowContent
        title="Activity of the client:"
        value={values?.clientActivityId as string}
        risk={
          values?.clientActivityRisk?.toString() !== 'null' &&
          values?.clientActivityRisk?.toString() !== 'undefined'
            ? (values?.clientActivityRisk?.toString() as string)
            : '-'
        }
        list={clientsActivities}
        name="privateIndividual"
        isEditable={isEditable}
      />
    </ExpandableRow>
  );
};

export default TypeOfClient;
